export default "__VITE_ASSET__BJAaC1sJ__"